import { render, staticRenderFns } from "./help-control.vue?vue&type=template&id=39c51980&"
import script from "./help-control.vue?vue&type=script&lang=js&"
export * from "./help-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports